var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-grid',{staticClass:"mask",attrs:{"cols":_vm.days.length}},_vm._l((_vm.cells),function(c,i){return _c('v-grid-cell',{key:i,class:c})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }